import React, { ButtonHTMLAttributes } from "react";

// =============================================================================
// BUTTON
// =============================================================================
// PURPOSE: Base button component with Apple design system principles.
// VARIANTS: primary, secondary, danger, ghost
// SIZES: sm, md, lg
// =============================================================================

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger" | "ghost";
  size?: "sm" | "md" | "lg";
}

const Button: React.FC<ButtonProps> = ({
  children,
  className = "",
  variant = "primary",
  size = "md",
  ...props
}) => {
  const baseClasses =
    "inline-flex items-center justify-center font-normal transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed";

  const sizeClasses = {
    sm: "px-3 py-1.5 text-sm rounded-lg",
    md: "px-5 py-2.5 text-sm rounded-xl",
    lg: "px-6 py-3 text-base rounded-xl",
  };

  const variantClasses = {
    primary: "bg-blue-500 text-glass hover:bg-blue-600 focus:ring-blue-500 shadow-sm anim-tap",
    secondary:
      "liquid-glass text-glass-secondary border border-black/[0.08] hover:bg-black/[0.03] focus:ring-black/20",
    danger: "bg-red-500 text-glass hover:bg-red-600 focus:ring-red-500 shadow-sm anim-tap",
    ghost:
      "text-glass-secondary hover:bg-black/[0.06] hover:text-glass focus:ring-black/20 anim-tap",
  };

  return (
    <button
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
